import lozad from 'lozad';

export const init = () => {
  const IMAGE_PRINTED = 'colorama-printed';

  CUBE.Analytics = CUBE.Analytics || {};
  CUBE.Analytics.enhanced.plv2 = Object.assign({}, CUBE.Analytics.enhanced.plv2, {
    es6: {

      getCurrentImage: element => {
        let image = element.querySelector('.plv2-el__images .plv2-el__image.slick-current')
        if (!image) image = element.querySelector('.plv2-el__images .plv2-el__image');
        return image;
      },
      getModelId: element => {
        const image = CUBE.Analytics.enhanced.plv2.es6.getCurrentImage(element);
        return (image) ? parseInt(image.dataset.modelid.trim(),10) : 0;
      },
      getSkuId: element => element.querySelector('.plv2-el__image').dataset.skuid.trim(),
      getName: element => element.querySelector('.plv2-el__name').textContent.trim(),
      getPrice: element => parseInt(element.querySelector('.plv2-el__price [data-price]').dataset.price.trim(),10),
      getBrand: element => element.querySelector('.plv2-el__brand').textContent.trim(),
      getSticker: element => {
        const sticker = element.querySelector('.plv2-el__sticker span');
        return (sticker) ? sticker.className.replace(`sticker-${tc_vars.env_language}`, '').trim() :
          '';
      },

      /**
       * Builds a MODEL object based on any part of the .plv2-element
       */
      getSelectedModel: (element, list) => {
        const dataset = element.dataset;
        return {
          type: dataset.page ? dataset.page.trim() : list,
          id: CUBE.Analytics.enhanced.plv2.es6.getModelId(element),
          sku: CUBE.Analytics.enhanced.plv2.es6.getSkuId(element),
          name: CUBE.Analytics.enhanced.plv2.es6.getName(element),
          brand: CUBE.Analytics.enhanced.plv2.es6.getBrand(element),
          position: dataset.index.trim(),
          list,
          price: CUBE.Analytics.enhanced.plv2.es6.getPrice(element),
          variant: dataset.nature.trim(),
          category: dataset.category.trim(),
          sticker: CUBE.Analytics.enhanced.plv2.es6.getSticker(element),

          vada: {
            family: dataset.family || '',
            department: dataset.department || '',
            subdepartment: dataset.subdepartment || '',
            universe: dataset.universe || ''
          }
        };
      },
      /**
       * Executed when a PLV2 element is visible in viewport
       */
      sendImpression: (element, list) => {
        const model = CUBE.Analytics.enhanced.plv2.es6.getSelectedModel(element, list);
        const displayedImage = CUBE.Analytics.enhanced.plv2.es6.getCurrentImage(element);
        if (displayedImage && !CUBE.Analytics.enhanced.plv2.es6.imageIsPrinted(displayedImage)) {
          CUBE.Analytics.enhanced.sendImpression(model);
          CUBE.Analytics.enhanced.plv2.es6.setImageAsPrinted(displayedImage);
        }
      },

      setImageAsPrinted: image => image.classList.add(IMAGE_PRINTED),

      imageIsPrinted: image => image.classList.contains(IMAGE_PRINTED),
      /**
       * Executed when a PLV2 colorama has changes
       */
      changeColorama: elt => {
        const element = elt.closest('.plv2-element');
        if (!element) return;

        const model = CUBE.Analytics.enhanced.plv2.es6.getSelectedModel(element);
        CUBE.Analytics.enhanced.plv2.es6.sendImpression(element, model.type);

        const defaultModelId = element.querySelector('[data-represent-model-id]').dataset.representModelId;

        // Not default modelId > Update Colorama
        if (defaultModelId !== model.id) {
          CUBE.Analytics.colorama.add(model.id, model.type);
        }

      },

      initImpression: (floorElement, type) => {

        const observer = lozad(`${floorElement} .plv2-element .plv2-el__image:not(.colorama-printed)`, {
          threshold: 0.5,
          loaded: element => {
            // adding viewed on every printed product
            element = element.closest('.plv2-element');
            if (!element) return;

            const id = element.dataset.productid;
            // sending impression only if the product has a product id in its dataset
            if (id) {
              CUBE.Analytics.enhanced.plv2.es6.sendImpression(element, type);
            }

          }
        });

        observer.observe();
      }

    }
  });
};



// WEBPACK FOOTER //
// ./src/analytics/framework/utils/plv2.js